import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

export const BankSchema = z.object({
  displayName: z.string(),
  imageUrl: z.string(),
});

export const GetBanksResponseDataSchema = z.object({
  banks: z.array(BankSchema),
});

export type Bank = z.infer<typeof BankSchema>;
export type GetBanksResponseData = z.infer<typeof GetBanksResponseDataSchema>;
export type GetBanksResponse = MusinsaStandardResponse<GetBanksResponseData>;
